import { Parte } from '../../../models/parte';


export class ParteAdapter {
  parte: Parte = new Parte();
  constructor(parte: Parte) {
    this.parte.id = parte.id;
    this.parte.nome = parte.nome;
    this.parte.cognome = parte.cognome;
    this.parte.codiceFiscale = parte.codiceFiscale;
    this.parte.dipendente = parte.dipendente;
    this.parte.matricola = parte.matricola;
    this.parte.ragioneSociale = parte.ragioneSociale;
    this.parte.partitaIva = parte.partitaIva;
    this.parte.codiceFiscaleRappresentanteLegale = parte.codiceFiscaleRappresentanteLegale;
    this.parte.dataNascita = parte.dataNascita;
    this.parte.indirizzo = parte.indirizzo;
    this.parte.cap = parte.cap;
    this.parte.telefono = parte.telefono;
    this.parte.cellulare = parte.cellulare;
    this.parte.email = parte.email;
    this.parte.pec = parte.pec;
    this.parte.note = parte.note;
    this.parte.tipoPersona = parte.tipoPersona ? JSON.parse(JSON.stringify(parte.tipoPersona)) : null;
    this.parte.tipoSocieta = parte.tipoSocieta ? JSON.parse(JSON.stringify(parte.tipoSocieta)) : null;
    this.parte.comuneNascita = parte.comuneNascita ? JSON.parse(JSON.stringify(parte.comuneNascita)) : null;
    this.parte.provinciaNascita = parte.provinciaNascita ? JSON.parse(JSON.stringify(parte.provinciaNascita)) : null;
    this.parte.comuneResidenza = parte.comuneResidenza ? JSON.parse(JSON.stringify(parte.comuneResidenza)) : null;
    this.parte.provinciaResidenza = parte.provinciaResidenza ? JSON.parse(JSON.stringify(parte.provinciaResidenza)) : null;
    this.parte.societa = parte.societa;
    this.parte.tipoContratto = parte.tipoContratto;
    //this.parte.tipoDipendente = parte.tipoDipendente;
    this.parte.statoDipendente = parte.statoDipendente;
    this.parte.figuraProfessionale = parte.figuraProfessionale;
    this.parte.unitaOrganizzativaAppartenenza = parte.unitaOrganizzativaAppartenenza;
    this.parte.unitaorganizzativautilita = parte.unitaorganizzativautilita;
    this.parte.dataAssunzione = parte.dataAssunzione;
    this.parte.dataCessazione = parte.dataCessazione;
    this.parte.albo = parte.albo;
    this.parte.numeroIscrizione = parte.numeroIscrizione;
    this.parte.codiceMeccanografico = parte.codiceMeccanografico;
    this.parte.sesso = parte.sesso ? parte.sesso : null;
    this.parte.vivente = parte.vivente;
    this.parte.nominativoOriginale = parte.nominativoOriginale;
  }
}
